const DEFAULT_LABELS = {
  provider_strategy: 'Assigned to',
  provider: 'Assigned to',
  document_priority: 'High priority',
  document_reviewed: 'Reviewed',
  notes: 'Description',
};

// Stored JSON comes back in MySQL's key order (shorter keys first), which
// would put the fallback provider before its strategy. Display in a fixed order.
const DISPLAY_ORDER = Object.keys(DEFAULT_LABELS);

export const orderedDocumentDefaults = (defaults) => Object.entries(defaults).sort(([a], [b]) => {
  const rank = (key) => (DISPLAY_ORDER.includes(key) ? DISPLAY_ORDER.indexOf(key) : DISPLAY_ORDER.length);
  return rank(a) - rank(b);
});

const documentDefaultLabel = (key) => DEFAULT_LABELS[key] || key.replace(/_/g, ' ');

export default documentDefaultLabel;
